import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import ProspectTracking from "../../Components/Tracking/ProspectTracking";
import OrganizationTracking from "../../Components/Tracking/OrganizationTracking";
import "./Tracking.css";
import { Button, InputBase, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import reload from "../../Assets/reloardform.svg";
import { APIDataUrl, APITokenUrl, GetUserId } from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import CloseIcon from "@mui/icons-material/Close";
import MessageModal from "../../Components/MessageModal/MessageModal";
import CustomSearchTrackingModal from "../../Components/Tracking/CustomSearchTrackingModal";
import CustomSearchTracking from "../../Components/Tracking/CustomSearchTracking";
const Tracking = () => {
  const [prospectData, setProspectData] = useState([]);
  const [organizationData, setOrganizationData] = useState([]);
  const [headerSearchData, setheaderSearchData] = useState("");
  const [showSearchdata, setshowSearchdata] = React.useState(false);
  const [responseData, setResponseData] = React.useState(null);
  const [loading, setLoading] = useState(false);
  const [messageModal, setMessageModal] = useState(false);
  const [deleteTrack, setDeleteTrack] = useState();
  const [selectedValue, setSelectedValue] = useState({});
  const [customSearchData, setCustomSearchData] = useState([]);
  const [openCustomSearchModal, setOpenCustomSearchModal] = useState(false);
  const [editCustomSearchData, setEditCustomSearchData] = useState([]);
  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);
  const handleEditCustomSearch = (item) => {
    setOpenCustomSearchModal(true);
    setEditCustomSearchData(item);
  };
  const handleTrackingdata = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_tracking?user_id=${Number(GetUserId())}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = e?.data?.data;
        // setProspectData(data?.filter((i) => i?.person_id !== null));
        // setOrganizationData(data?.filter((i) => i?.person_id === null));

        setProspectData(
          data
            ?.filter((i) => i?.person_id !== null)
            ?.filter(
              (i) =>
                new Date(i.track_until).toISOString().split("T")[0] >
                new Date().toISOString().split("T")[0],
            ),
        );
        setOrganizationData(
          data
            ?.filter((i) => i?.request_type === "company_of_intrest")
            ?.filter(
              (i) =>
                new Date(i.track_until).toISOString().split("T")[0] >
                new Date().toISOString().split("T")[0],
            ),
        );
        setCustomSearchData(
          data
            ?.filter((i) => i?.request_type === "custom_search")
            ?.filter(
              (i) =>
                new Date(i.track_until).toISOString().split("T")[0] >
                new Date().toISOString().split("T")[0],
            ),
        );
      })
      .catch((err) => {});
  };
  const handleRefreshTrackingdata = (item) => {
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/refresh_tracking?request_id=${
        item?.request_id
      }`,
    };
    axios(option)
      .then((e) => {
        toast.success(
          `${item?.person_id == null ? "Organization " : "Prospect "}refreshed.`,
        );
        handleTrackingdata();
      })
      .catch((err) => {});
  };
  useEffect(() => {
    handleTrackingdata();
  }, []);
  const emtySearchdata = () => {
    setheaderSearchData("");
  };
  React.useEffect(() => {
    const handleClick = () => {
      setshowSearchdata(false);
      setheaderSearchData("");
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  // const handlesearch = () => {
  //   setLoading(true);
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "X-API-Key": APITokenUrl(),
  //     },
  //     url: `${APIDataUrl()}/v1/common_search?query=${headerSearchData}&page=1&limit=100`,
  //   };
  //   axios(option)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setLoading(false);
  //         setshowSearchdata(true);
  //         const orgdata = response.data.organizations?.map((i) => ({
  //           ...i,
  //           type: "org",
  //         }));
  //         const peopleData = response.data.people?.map((i) => ({
  //           ...i,
  //           type: "people",
  //         }));
  //         const allData = [{ id: null, name: "Prospects" }, ...peopleData, { id: null, name: "Organizations" }, ...orgdata]
  //         setResponseData(allData);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       toast.error(error.response.data.message);
  //     });
  // };
  const handlesearch = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/common_search?query=${headerSearchData}&page=1&limit=100`,
    };
    axios(option)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setshowSearchdata(true);
          const orgHeading = {
            id: null,
            name: "Organizations",
            type: "heading",
          };
          const orgdata =
            response.data.organizations?.map((i) => ({ ...i, type: "org" })) ||
            [];
          const prospectHeading = {
            id: null,
            name: "Prospects",
            type: "heading",
          };
          const peopleData =
            response.data.people?.map((i) => ({ ...i, type: "people" })) || [];
          const sortedOrgData = orgdata.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
          );
          const sortedPeopleData = peopleData.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
          );
          const orderedData = [
            orgHeading,
            ...sortedOrgData,
            prospectHeading,
            ...sortedPeopleData,
          ];
          setResponseData(orderedData);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response?.data?.message);
      });
  };
  React.useEffect(() => {
    let timer;
    if (headerSearchData?.length > 2) {
      timer = setTimeout(() => {
        handlesearch();
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [headerSearchData]);
  const handleSaveTrack = (item) => {
    setSelectedValue(item);
    setMessageModal(true);
  };
  const handleTrackRecords = () => {
    if (selectedValue?.type === "org") {
      handleSaveOrganizationTrack(selectedValue);
    } else {
      handleSavePeopleTrack(selectedValue);
    }
  };
  const handleSaveOrganizationTrack = (item) => {
    setLoading(true);
    const data = [item?.org_id];
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/save_tracking_organization?user_id=${Number(
        GetUserId(),
      )}`,
    };
    axios(option)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setshowSearchdata(false);
          toast.success("Tracking Added");
          handleTrackingdata();
          setResponseData([]);
          setMessageModal(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };
  const handleSavePeopleTrack = (item) => {
    setLoading(true);
    const data = [item?.id];
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/save_tracking_prospect?user_id=${Number(
        GetUserId(),
      )}`,
    };
    axios(option)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setshowSearchdata(false);
          toast.success("Tracking Added");
          handleTrackingdata();
          setResponseData([]);
          setMessageModal(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };
  const handleDeleteTracking = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/delete_tracking?request_id=${
        deleteTrack?.request_id
      }`,
    };
    axios(option)
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          toast.success("Tracking Record Deleted Successfully");
          setDeleteTrack();
          handleTrackingdata();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };

  return (
    <Layout>
      {loading ? <Loader /> : null}
      <div className="table-tracking">
      <h1 className="tracking-page-headline-tab">
        Create Prospect, Organization or Custom News Search Tracking
      </h1>
        <p className="track-text-grey">
          Stay informed by integrating competitive intelligence article feeds
          that monitor tracked organizations and prospects in real-time.
        </p>
        <p className="tracking_label">Prospect and Organization Tracking:</p>
        <Paper
          className="track-full-searchbar"
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: 280,
          }}
        >
          <SearchIcon className="searchicon-in-header" />
          <InputBase
            value={headerSearchData}
            onChange={(e) => {
              const inputValue = e.target.value;
              setheaderSearchData(inputValue);
            }}
            className="search-inner-text"
            sx={{ ml: 1, flex: 1 }}
            placeholder={"Search by Organization or Prospect Name"}
            inputProps={{ "aria-label": "Search google maps" }}
            autoComplete="off"
          />
          <div onClick={emtySearchdata} className="cross-icon-prospect-search">
            {headerSearchData && <CloseIcon className="showicons-search" />}
          </div>
          {showSearchdata && (
            <div className="Autocompletedropdown-track">
              {/* {responseData?.length > 0 ? (
                responseData?.map((item) => (
                  <>
                    {
                      item?.id ? <div className="outterAutocompletedropdown" key={item.id}>
                        <div
                          onClick={() => handleSaveTrack(item)}
                          className="useralldata"
                        >
                          {[
                            item?.name,
                            item?.state,
                            item?.country,
                            item?.website_url,
                            item?.organization,
                            item?.seniority,
                            item?.linked_url,
                          ]
                            .filter(Boolean)
                            .join(", ")}
                        </div>
                        <div className="separatorline"></div>
                      </div> : <div className='outterAutocompletedropdown2' key={item.id}>
                        <div className='useralldata'>
                          {item?.name}
                        </div>
                        <div className='separatorline'></div>
                      </div>
                    }
                  </>
                ))
              ) : (
                <div className="useralldata">Not Available</div>
              )} */}
              {responseData?.length > 0 ? (
                responseData.map((item, index) => (
                  <>
                    {item?.id === null ? (
                      <div
                        className="outterAutocompletedropdown2"
                        key={`heading-${index}`}
                      >
                        <div className="useralldata-tracking">
                          <strong>{item?.name}</strong>
                        </div>
                        <div className="separatorline"></div>
                      </div>
                    ) : (
                      <div
                        className="outterAutocompletedropdown"
                        key={item.id || `data-${index}`}
                      >
                        <div
                          onClick={() => handleSaveTrack(item)}
                          className="useralldata-tracking"
                        >
                          {[
                            item?.name?.toLowerCase() === "jp nauseef"
                              ? "JP Nauseef"
                              : item?.name
                                  ?.split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1).toLowerCase(),
                                  )
                                  .join(" "),
                            item?.state
                              ?.split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() +
                                  word.slice(1).toLowerCase(),
                              )
                              .join(" "),
                            item?.country
                              ?.split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() +
                                  word.slice(1).toLowerCase(),
                              )
                              .join(" "),
                            item?.website_url?.toLowerCase(),
                            item?.organization
                              ?.split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() +
                                  word.slice(1).toLowerCase(),
                              )
                              .join(" "),
                            item?.seniority
                              ?.split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() +
                                  word.slice(1).toLowerCase(),
                              )
                              .join(" "),
                            item?.linked_url,
                          ]
                            .filter(Boolean)
                            .join(", ")}
                        </div>
                        <div className="separatorline"></div>
                      </div>
                    )}
                  </>
                ))
              ) : (
                <div className="useralldata-tracking">Not Available</div>
              )}
            </div>
          )}
        </Paper>
        <p className="tracking_label">Custom News Search:</p>
      <p className="track-text-grey">
        Enhance your tracking capabilities by creating customized keyword
        combinations into unified monitoring instances. This strategic
        approach allows you to efficiently discover and analyze news
        articles specifically related to your selected keyword combinations
        including Organizations, People, States and Industry, providing you
        comprehensive competitive insights.
      </p>
        <Button
          className="de_next"
          style={{ marginTop: "20px" }}
          onClick={() => setOpenCustomSearchModal(true)}
        >
          Create a Custom News Search
        </Button>
      <p className="track_inner_p">
        Tracking will automatically expire after 60 days. You can renew
        tracking for an additional 60 days by clicking the
        <span>
          <img src={reload} alt="reload" />
        </span>
        renew button in your list below. The 60-day period will restart from
        the day you click the renew button.
      </p>
        {/* <p className="track_inner_p">
          Tracking will automatically expire after 60 days. You can renew
          tracking for an additional 60 days by clicking
          <span>
            <img src={reload} alt="reload" />
          </span>
          button in your list below.
        </p> */}
      </div>
      <MessageModal
        open={messageModal}
        setOpen={setMessageModal}
        message={`Are you sure that you want to add this ${
          selectedValue?.type === "org" ? "organization" : "prospect"
        } to tracking?`}
        handleSubmit={handleTrackRecords}

      />
      <MessageModal
        open={deleteTrack?.request_id}
        setOpen={setDeleteTrack}
        message={`Are you sure that you want to stop tracking this record?`}
        handleSubmit={handleDeleteTracking}

      />
      <ProspectTracking


        prospectData={prospectData}
        handleRefreshTrackingdata={handleRefreshTrackingdata}
        handleDeleteTracking={setDeleteTrack}
        setLoading={setLoading}
      />
      <OrganizationTracking


        organizationData={organizationData}
        handleRefreshTrackingdata={handleRefreshTrackingdata}
        handleDeleteTracking={setDeleteTrack}
        setLoading={setLoading}
      />
    <p className="track_inner_p2">
      Tracking will automatically expire after 7 days. You can renew
      tracking for an additional 7 days by clicking the
      <span>
        <img src={reload} alt="reload" />
      </span>
      renew button in your list below. The 7-day period will restart from
      the day you click the renew button.
    </p>
      <CustomSearchTracking


        organizationData={customSearchData}
        handleRefreshTrackingdata={handleRefreshTrackingdata}
        handleDeleteTracking={setDeleteTrack}
        handleEdit={handleEditCustomSearch}
        setLoading={setLoading}
      />
    <CustomSearchTrackingModal
      openCustomSearchModal={openCustomSearchModal}
      setOpenCustomSearchModal={setOpenCustomSearchModal}
      setLoading={setLoading}
      editCustomSearchData={editCustomSearchData}
      setEditCustomSearchData={setEditCustomSearchData}
      handleTrackingdata={handleTrackingdata}
    />
    </Layout>
  );
};
export default Tracking;
